import { render, staticRenderFns } from "./IkkatsuFieldUpload.vue?vue&type=template&id=756cb830&"
import script from "./IkkatsuFieldUpload.vue?vue&type=script&lang=ts&"
export * from "./IkkatsuFieldUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports